import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type LanguageChangedEventInit = {
  /** Current selected language */
  language: 'pl' | 'en';
};

/**
 * An event that is fired on language change in the editor.
 * No result is expected.
 *
 * @eventName "flotiq.language::changed"
 * @memberof FlotiqPlugins.Events
 */
export class LanguageChangedEvent extends IFlotiqPluginEvent {
  constructor(initData: LanguageChangedEventInit) {
    super(initData);
  }
}
